import { useHistory, useLocation } from 'react-router-dom'
import routes from '../../router/routes'
import { LogosContainer } from './styles'
import { useCallback } from 'react'

const Logo = ({ invertColors = false }: { invertColors?: boolean }) => {
  const { push } = useHistory()
  const { pathname } = useLocation()
  const isKoreanBlockchainWeekPage =
    pathname.includes('/kbw') || pathname.includes('/kbcw')
  const toMain = useCallback(() => push(routes.home), [push])

  return (
    <LogosContainer onClick={toMain}>
      <img
        src={`/${isKoreanBlockchainWeekPage ? 'kbcw-' : ''}logo.svg`}
        alt="zap logo"
        style={{ filter: invertColors ? 'saturate(0) invert(1)' : 'none' }}
      />
    </LogosContainer>
  )
}

export default Logo
